import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/Login'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '首页'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js